import SectionErrorRoute from 'garaje/utils/section-error-route';

// Catch-all for every section under current-location: any route failure that
// no nearer `<section>-error` substate handles renders the panel here, inside
// the protected layout, instead of falling through to the full-page global
// error route.
export default class CurrentLocationErrorRoute extends SectionErrorRoute {
  get section() {
    return this.router.currentURL?.split('?')[0]?.split('/')[1] || 'unknown';
  }
}
